/**
 * The assistant's one name, and the labels built on it. Every entry point
 * (sidebar, top bar, panel) says "Ask Graphit"; the setup surfaces' buttons
 * say "Get help with this step".
 */
export const ASK_GRAPHIT = 'Ask Graphit'
/** `AskAssistantButton`'s label with a `setupContext`. */
export const GET_HELP_WITH_STEP = 'Get help with this step'
/** Setup help on a page that is not a step (Settings → Integrations). */
export const GET_HELP_CONNECTING_DATA = 'Get help connecting your data'

// Setup help (a setup-scoped conversation, free while `status.setup_chat` is available)
export const SETUP_HELP_TITLE = 'Get Graphit set up.'
export const SETUP_HELP_INTRO = 'Ask how to connect your data, finish a setup step, or what is left on your checklist.'
export const SETUP_HELP_STARTERS = [
  'How do I connect Rock?',
  'What’s left on my checklist?',
  'How do I import a spreadsheet?',
]
export const SETUP_HELP_FREE = 'Setup help is free and doesn’t use your plan’s AI allowance.'
export const SETUP_HELP_USED_UP = 'Free setup help is used up. Replies now count toward your plan’s AI allowance.'
